<template>
  <div class="product-detail">
    <h2 class="product-detail__name">{{ product.name }}</h2>

    <p class="product-detail__text semibold" v-html="product.description"></p>
    <p v-if="product.details" class="product-detail__text" v-html="product.details"></p>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';

  export default {
    name: 'product-detail',

    computed: {
      ...mapGetters('livegift', { product: 'selected_product_data' }),
    },
  };
</script>

<style lang="scss" scoped>

  .product-detail {
    min-height: 160px;

    &__name {
      margin: 0;
      font-size: $font-size-xl;
      font-weight: $vb-font-weight-semibold;
      color: $gray-900;
    }

    &__text {
      margin: ($grid-gutter-width / 3) 0 0;
      font-size: $font-size-md;
      color: $gray-700;

      &:last-child {
        margin-top: $grid-gutter-20
      }
    }
  }
</style>